import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showLoading, showAlert } from "../Actions/GeneralActions";
import { headers } from "../../utills";
import {
  WeeklyChecklist,
  MonthlyChecklist,
  allCheckList,
  getCalendarCheckList,
} from "../Actions/EventAction";
import { clearYourVendors, getYourVendors } from "../Actions/VendorActions";

export const CheckListMiddleware = {
  getCheckList: (eventData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", eventData?.id);
          if (eventData?.status) formdata.append("status", eventData?.status);
          const data = await Axios.post(
            Apis.checklists,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            if (eventData?.status == "weekly") {
              dispatch(WeeklyChecklist(data?.data?.data));
            } else if (eventData?.status == "monthly") {
              dispatch(MonthlyChecklist(data?.data?.data));
            } else {
              dispatch(allCheckList(data?.data?.data));
            }
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get CheckList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createCheckList: (checklistData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", checklistData?.id);
          formdata.append("name", checklistData?.taskName);
          // formdata.append("time", checklistData?.time);
          formdata.append("date", checklistData?.date);
          // formdata.append("remind_after", checklistData?.hours);
          formdata.append("description", checklistData?.description);
          // for (const [i, document] of checklistData?.subtaskList.entries()) {
          //   formdata.append(`subtasks[${i}][name]`, document?.name);
          // }
          const data = await Axios.post(
            Apis.createChecklist,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            resolve(data?.data?.data);
            if (checklistData?.status == "weekly") {
              dispatch(WeeklyChecklist(data?.data?.data));
            } else {
              dispatch(allCheckList(data?.data?.data));
            }
            dispatch(
              showAlert({
                title: "Create CheckList",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Create CheckList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  editCheckList: (checklistData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", checklistData?.task_id);
          formdata.append("name", checklistData?.taskName);
          formdata.append("time", checklistData?.time);
          formdata.append("date", checklistData?.date);
          formdata.append("remind_after", checklistData?.hours);
          formdata.append("description", checklistData?.description);
          if (checklistData?.status)
            formdata.append("status", checklistData?.status);
          // if (checklistData?.subtaskList?.length > 0) {
          //   for (const [i, document] of checklistData?.subtaskList.entries()) {
          //     if (document?.id)
          //       formdata.append(`subtasks[${i}][id]`, document?.id);
          //     formdata.append(`subtasks[${i}][name]`, document?.name);
          //   }
          // } else {
          //   formdata.append(`subtasks`, []);
          // }

          console.log("object====", formdata);
          const data = await Axios.post(
            Apis.updateChecklist,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            resolve(data?.data?.data);
            if (checklistData?.status == "weekly") {
              dispatch(WeeklyChecklist(data?.data?.data));
            } else if (checklistData?.status == "monthly") {
              dispatch(MonthlyChecklist(data?.data?.data));
            } else {
              dispatch(allCheckList(data?.data?.data));
            }
            dispatch(
              showAlert({
                title: "Create CheckList",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Create CheckList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  onCheckDone: (checkListData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", checkListData?.task_id);
          formdata.append("event_id", checkListData?.event_id);
          if (checkListData?.status)
            formdata.append("status", checkListData?.status);
          const data = await Axios.post(
            Apis.updateChecklistStatus,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            resolve(data?.data?.data);
            if (checkListData?.status == "weekly") {
              dispatch(WeeklyChecklist(data?.data?.data));
            } else if (checkListData?.status == "monthly") {
              dispatch(MonthlyChecklist(data?.data?.data));
            } else {
              dispatch(allCheckList(data?.data?.data));
            }
            dispatch(
              showAlert({
                title: "Update CheckList",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Update CheckList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  onDeleteTask: (checkListData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", checkListData?.task_id);
          formdata.append("event_id", checkListData?.event_id);
          if (checkListData?.status)
            formdata.append("status", checkListData?.status);
          const data = await Axios.post(
            Apis.deleteChecklist,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            if (checkListData?.status == "weekly") {
              dispatch(WeeklyChecklist(data?.data?.data));
            } else if (checkListData?.status == "monthly") {
              dispatch(MonthlyChecklist(data?.data?.data));
            } else {
              dispatch(allCheckList(data?.data?.data));
            }
            dispatch(
              showAlert({
                title: "Delete CheckList",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Delete CheckList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getCalendarCheckList: (eventData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", eventData?.id);
          formdata.append("date", eventData?.date);
          const data = await Axios.post(
            Apis.calenderChecklists,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(getCalendarCheckList(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get CheckList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getEventVendors: (vendor_data) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          if (
            vendor_data?.vendor_name ||
            vendor_data?.next_page_url == undefined
          ) {
            if (vendor_data?.vendor_name && vendor_data?.next_page_url) {
            } else {
              dispatch(clearYourVendors());
            }
          }
          let formData = new FormData();
          formData.append("vendor_name", vendor_data?.vendor_name);
          formData.append("event_id", vendor_data?.event_id);
          if (vendor_data?.category_id)
            formData.append("category_id", vendor_data?.category_id);
          const data = await Axios.post(
            Apis.getYourVendor(vendor_data?.next_page_url),
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getYourVendors(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getEventVendors",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  sendCheckList: (checkListData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("checklist_id", checkListData?.checklist_id);
          formdata.append("event_id", checkListData?.event_id);
          formdata.append("vendor_id", checkListData?.vendor_id);
          const data = await Axios.post(
            Apis.checklistAssignToVendors,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Send CheckList",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Send CheckList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
